import * as API from 'core/api';
import { TicketDTO } from 'core/api';
import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function getBy(date: Date, idTable: string): Promise<API.OnlineReservationInListDTO[]> {
	const request = new API.GetAvailableOnlineReservationsRequest({ date, idTable });
	return process(request, (response: API.GetAvailableOnlineReservationsResponse) => response.Reservations);
}

export async function getDetails(ticket: TicketDTO): Promise<API.OnlineReservationInListDTO> {
	const request = new API.FindOnlineReservationDetailsRequest({ ticketId: ticket.Id });
	return process(request, (response: API.FindOnlineReservationDetailsResponse) => response.Reservation);
}

export async function setReservation(ticketId: number, reservation: API.OnlineReservationInListDTO): Promise<void> {
	await process(new API.AttendOnlineReservationRequest({
		ticketId,
		originalLocation: reservation.Location,
		tableCompanions: reservation.Companions,
		customer: reservation.Customer,
		startTime: reservation.StartTime,
		endTime: reservation.EndTime,
		notes: reservation.Notes,
		reservationCode: reservation.ReservationCode,
		prepaymentAmount: reservation.PrepaymentAmount,
		offerCode: reservation.OfferCode
	}));
}

export async function removeReservation(ticketId: number): Promise<void> {
	await process(new API.RemoveOnlineReservationRequest({ ticketId }));
}